import React from 'react';

export default () => {
  return (<h1>Information</h1>)
}
